import { Badge, BlockStack, Button, Divider, InlineStack, Modal, Text } from '@shopify/polaris';
import React, { useCallback, useRef, useState } from 'react'
import ReactPlayer from 'react-player';
import { DI, DIProps } from '../../../../Core';
import '../css/styles.css';
import { useTranslation } from 'react-i18next';

interface props extends DIProps {
    modalURLandHead: any
    active: boolean
    setActive: (val: boolean) => void
}
const VideoPlayerModal = (props: props) => {
    const { t } = useTranslation();
    const { modalURLandHead, active, setActive } = props;
    const playerRef: any = useRef(null);
    const [currentTimeStamp, setCurrentTimeStamp] = useState<any>(0);
    const handleChange = useCallback(() => setActive(!active), [active]);

    const handleSeek = (seconds: any) => {
        if (playerRef.current) {
            playerRef.current.seekTo(seconds);  // Call seekTo method on the React Player instance
        }
    };

    const handleProgress = (progress: any) => {
        setCurrentTimeStamp(Math.round(progress?.playedSeconds))
    }

    const getTimeStamp = (startTime: any) => {
        let timeStamp: any = '';
        if (startTime < 60) {
            timeStamp = `00:${startTime}`;
        }
        else {
            let min = Math.floor(+startTime / 60);
            let sec = +startTime % 60;
            timeStamp = `${min}: ${sec}`;
        }
        return timeStamp;
    }

    return (
        <Modal
            open={active}
            onClose={handleChange}
            title={modalURLandHead?.heading}
            footer={<Button onClick={handleChange}>{t("Dismiss")}</Button>}
        >
            <Modal.Section>
                <BlockStack gap="500">
                    <div style={{ minWidth: '100%', minHeight: '315px' }} >
                        <ReactPlayer
                            ref={playerRef}
                            width="100%"
                            controls={true}
                            muted={true}
                            config={{ youtube: { playerVars: { showinfo: 1 } } }}
                            playing={true}
                            seekTo={"15"}
                            // onDuration={(duration) => setTotalDuration(duration)}
                            onProgress={(progress) => handleProgress(progress)}
                            url={`https://www.youtube.com/watch?v=${modalURLandHead?.url}`}
                        />
                    </div>
                    <Divider />
                    <BlockStack gap="400">
                        <Text as="p" variant='headingMd' >{t("Follow these Steps to List a single product")}</Text>
                        <BlockStack gap='300'>
                            {Object.keys(modalURLandHead).length > 0 && modalURLandHead?.timeStamp?.sort((a: any, b: any) => parseInt(a.start) - parseInt(b.start))?.map((timestamp: any, count: number) => {
                                return (
                                    <div key={timestamp?.start} onKeyDown={(event) => {
                                        if (event.key === 'Enter' || event.key === ' ') {
                                            handleSeek(timestamp?.start);
                                        }
                                    }} onClick={() => handleSeek(timestamp?.start)} className={(currentTimeStamp > parseInt(timestamp.start) && currentTimeStamp <= parseInt(timestamp.end)) ? 'Custom__TimeStamp active' : "Custom__TimeStamp"}>
                                        <InlineStack gap='100'>
                                            <Badge tone={(currentTimeStamp > parseInt(timestamp.start) && currentTimeStamp <= parseInt(timestamp.end)) ? 'info' : 'new'}>{getTimeStamp(timestamp?.start)}</Badge>
                                            <InlineStack gap="100">
                                                <Text as="span" fontWeight='semibold'>{`${t("Step")} ${count}: `}</Text>
                                                <Text as="span">{timestamp?.title}</Text>
                                            </InlineStack>
                                        </InlineStack>
                                    </div>
                                )
                            })}
                        </BlockStack>
                    </BlockStack>
                </BlockStack>
            </Modal.Section>
        </Modal>
    )
}

export default DI(VideoPlayerModal)